/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../api/graphql/API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const adminDeleteDiscussionMessage = /* GraphQL */ `mutation AdminDeleteDiscussionMessage($input: DeleteDiscussionMessageInput!) {
  adminDeleteDiscussionMessage(input: $input)
}
` as GeneratedMutation<
  APITypes.AdminDeleteDiscussionMessageMutationVariables,
  APITypes.AdminDeleteDiscussionMessageMutation
>;
export const adminDeleteDiscussionTopic = /* GraphQL */ `mutation AdminDeleteDiscussionTopic($input: DeleteDiscussionTopicInput!) {
  adminDeleteDiscussionTopic(input: $input)
}
` as GeneratedMutation<
  APITypes.AdminDeleteDiscussionTopicMutationVariables,
  APITypes.AdminDeleteDiscussionTopicMutation
>;
export const adminUpdateDiscussionMessage = /* GraphQL */ `mutation AdminUpdateDiscussionMessage(
  $input: AdminUpdateDiscussionMessageInput!
) {
  adminUpdateDiscussionMessage(input: $input) {
    additional_data
    approved
    created_at
    dislikes
    id
    last_updated_at
    likes
    message_content
    reference
    reply_message_delete_count
    reply_messages
    reply_messages_add_count
    s3_objects
    s3_objects_add_count
    s3_objects_delete_count
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AdminUpdateDiscussionMessageMutationVariables,
  APITypes.AdminUpdateDiscussionMessageMutation
>;
export const adminUpdateDiscussionTopic = /* GraphQL */ `mutation AdminUpdateDiscussionTopic($input: AdminUpdateDiscussionTopicInput!) {
  adminUpdateDiscussionTopic(input: $input) {
    addition_data
    approved
    content
    created_at
    id
    last_updated_at
    reference
    reply_message_add_count
    reply_message_delete_count
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AdminUpdateDiscussionTopicMutationVariables,
  APITypes.AdminUpdateDiscussionTopicMutation
>;
export const createArticleVote = /* GraphQL */ `mutation CreateArticleVote($input: CreateArticleVoteInput!) {
  createArticleVote(input: $input) {
    additional_data
    created_at
    id
    reference
    user_sub
    vote
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateArticleVoteMutationVariables,
  APITypes.CreateArticleVoteMutation
>;
export const createAskPCOSUser = /* GraphQL */ `mutation CreateAskPCOSUser($input: CreateAskPCOSUserInput!) {
  createAskPCOSUser(input: $input) {
    additional_data
    badges
    bookmarked_articles
    consent
    country
    created_at
    email
    firstname
    height
    id
    last_updated_at
    lastname
    pcos_diagnosed
    phone_number
    read_articles
    selected_questions_qpl
    self_assessment
    use_smart_goal
    user_sub
    weight
    weight_history
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAskPCOSUserMutationVariables,
  APITypes.CreateAskPCOSUserMutation
>;
export const createCheckIn = /* GraphQL */ `mutation CreateCheckIn($input: CreateCheckInInput!) {
  createCheckIn(input: $input) {
    dateTime
    feelingScale
    goalCompleted
    goalId
    id
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCheckInMutationVariables,
  APITypes.CreateCheckInMutation
>;
export const createDiscussionMessage = /* GraphQL */ `mutation CreateDiscussionMessage($input: CreateDiscussionMessageInput!) {
  createDiscussionMessage(input: $input) {
    additional_data
    approved
    created_at
    dislikes
    id
    last_updated_at
    likes
    message_content
    reference
    reply_message_delete_count
    reply_messages
    reply_messages_add_count
    s3_objects
    s3_objects_add_count
    s3_objects_delete_count
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDiscussionMessageMutationVariables,
  APITypes.CreateDiscussionMessageMutation
>;
export const createDiscussionTopic = /* GraphQL */ `mutation CreateDiscussionTopic($input: CreateDiscussionTopicInput!) {
  createDiscussionTopic(input: $input) {
    addition_data
    approved
    content
    created_at
    id
    last_updated_at
    reference
    reply_message_add_count
    reply_message_delete_count
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDiscussionTopicMutationVariables,
  APITypes.CreateDiscussionTopicMutation
>;
export const createGoal = /* GraphQL */ `mutation CreateGoal($input: CreateGoalInput!) {
  createGoal(input: $input) {
    completed_goal
    forNoPeriods
    goalId
    id
    monthPeriod
    noTimesInPeriod
    obstacle
    response
    selectedSolution
    solutions
    startDate
    title
    user_sub
    yearPeriod
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGoalMutationVariables,
  APITypes.CreateGoalMutation
>;
export const createHabit = /* GraphQL */ `mutation CreateHabit($input: CreateHabitInput!) {
  createHabit(input: $input) {
    categoryId
    description
    iconName
    id
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHabitMutationVariables,
  APITypes.CreateHabitMutation
>;
export const createHabitCategory = /* GraphQL */ `mutation CreateHabitCategory($input: CreateHabitCategoryInput!) {
  createHabitCategory(input: $input) {
    defaultIconName
    id
    name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHabitCategoryMutationVariables,
  APITypes.CreateHabitCategoryMutation
>;
export const createSymptomsTrackerDataType = /* GraphQL */ `mutation CreateSymptomsTrackerDataType(
  $input: CreateSymptomsTrackerDataTypeInput!
) {
  createSymptomsTrackerDataType(input: $input) {
    additional_data
    created_at
    day
    full_date
    id
    last_updated_at
    month
    symptoms_data
    user_sub
    user_sub_year
    user_sub_year_month
    year
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSymptomsTrackerDataTypeMutationVariables,
  APITypes.CreateSymptomsTrackerDataTypeMutation
>;
export const deleteArticleVote = /* GraphQL */ `mutation DeleteArticleVote($input: DeleteArticleVoteInput!) {
  deleteArticleVote(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteArticleVoteMutationVariables,
  APITypes.DeleteArticleVoteMutation
>;
export const deleteAskPCOSUser = /* GraphQL */ `mutation DeleteAskPCOSUser($input: DeleteAskPCOSUserInput!) {
  deleteAskPCOSUser(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteAskPCOSUserMutationVariables,
  APITypes.DeleteAskPCOSUserMutation
>;
export const deleteCheckIn = /* GraphQL */ `mutation DeleteCheckIn($input: DeleteCheckInInput!) {
  deleteCheckIn(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteCheckInMutationVariables,
  APITypes.DeleteCheckInMutation
>;
export const deleteDiscussionMessage = /* GraphQL */ `mutation DeleteDiscussionMessage($input: DeleteDiscussionMessageInput!) {
  deleteDiscussionMessage(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteDiscussionMessageMutationVariables,
  APITypes.DeleteDiscussionMessageMutation
>;
export const deleteDiscussionTopic = /* GraphQL */ `mutation DeleteDiscussionTopic($input: DeleteDiscussionTopicInput!) {
  deleteDiscussionTopic(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteDiscussionTopicMutationVariables,
  APITypes.DeleteDiscussionTopicMutation
>;
export const deleteGoal = /* GraphQL */ `mutation DeleteGoal($input: DeleteGoalInput!) {
  deleteGoal(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteGoalMutationVariables,
  APITypes.DeleteGoalMutation
>;
export const deleteHabit = /* GraphQL */ `mutation DeleteHabit($input: DeleteHabitInput!) {
  deleteHabit(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteHabitMutationVariables,
  APITypes.DeleteHabitMutation
>;
export const deleteHabitCategory = /* GraphQL */ `mutation DeleteHabitCategory($input: DeleteHabitCategoryInput!) {
  deleteHabitCategory(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteHabitCategoryMutationVariables,
  APITypes.DeleteHabitCategoryMutation
>;
export const deleteSymptomsTrackerDataType = /* GraphQL */ `mutation DeleteSymptomsTrackerDataType(
  $input: DeleteSymptomsTrackerDataTypeInput!
) {
  deleteSymptomsTrackerDataType(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteSymptomsTrackerDataTypeMutationVariables,
  APITypes.DeleteSymptomsTrackerDataTypeMutation
>;
export const updateAskPCOSUser = /* GraphQL */ `mutation UpdateAskPCOSUser($input: UpdateAskPCOSUserInput!) {
  updateAskPCOSUser(input: $input) {
    additional_data
    badges
    bookmarked_articles
    consent
    country
    created_at
    email
    firstname
    height
    id
    last_updated_at
    lastname
    pcos_diagnosed
    phone_number
    read_articles
    selected_questions_qpl
    self_assessment
    use_smart_goal
    user_sub
    weight
    weight_history
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAskPCOSUserMutationVariables,
  APITypes.UpdateAskPCOSUserMutation
>;
export const updateCheckIn = /* GraphQL */ `mutation UpdateCheckIn($input: UpdateCheckInInput!) {
  updateCheckIn(input: $input) {
    dateTime
    feelingScale
    goalCompleted
    goalId
    id
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCheckInMutationVariables,
  APITypes.UpdateCheckInMutation
>;
export const updateDiscussionMessage = /* GraphQL */ `mutation UpdateDiscussionMessage($input: UpdateDiscussionMessageInput!) {
  updateDiscussionMessage(input: $input) {
    additional_data
    approved
    created_at
    dislikes
    id
    last_updated_at
    likes
    message_content
    reference
    reply_message_delete_count
    reply_messages
    reply_messages_add_count
    s3_objects
    s3_objects_add_count
    s3_objects_delete_count
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDiscussionMessageMutationVariables,
  APITypes.UpdateDiscussionMessageMutation
>;
export const updateDiscussionTopic = /* GraphQL */ `mutation UpdateDiscussionTopic($input: UpdateDiscussionTopicInput!) {
  updateDiscussionTopic(input: $input) {
    addition_data
    approved
    content
    created_at
    id
    last_updated_at
    reference
    reply_message_add_count
    reply_message_delete_count
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDiscussionTopicMutationVariables,
  APITypes.UpdateDiscussionTopicMutation
>;
export const updateGoal = /* GraphQL */ `mutation UpdateGoal($input: UpdateGoalInput!) {
  updateGoal(input: $input) {
    completed_goal
    forNoPeriods
    goalId
    id
    monthPeriod
    noTimesInPeriod
    obstacle
    response
    selectedSolution
    solutions
    startDate
    title
    user_sub
    yearPeriod
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGoalMutationVariables,
  APITypes.UpdateGoalMutation
>;
export const updateHabit = /* GraphQL */ `mutation UpdateHabit($input: UpdateHabitInput!) {
  updateHabit(input: $input) {
    categoryId
    description
    iconName
    id
    user_sub
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHabitMutationVariables,
  APITypes.UpdateHabitMutation
>;
export const updateHabitCategory = /* GraphQL */ `mutation UpdateHabitCategory($input: UpdateHabitCategoryInput!) {
  updateHabitCategory(input: $input) {
    defaultIconName
    id
    name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHabitCategoryMutationVariables,
  APITypes.UpdateHabitCategoryMutation
>;
export const updateSymptomsTrackerDataType = /* GraphQL */ `mutation UpdateSymptomsTrackerDataType(
  $input: UpdateSymptomsTrackerDataTypeInput!
) {
  updateSymptomsTrackerDataType(input: $input) {
    additional_data
    created_at
    day
    full_date
    id
    last_updated_at
    month
    symptoms_data
    user_sub
    user_sub_year
    user_sub_year_month
    year
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSymptomsTrackerDataTypeMutationVariables,
  APITypes.UpdateSymptomsTrackerDataTypeMutation
>;
